import React from 'react'
import PropTypes from 'prop-types'
import LPFAQSection from './LPFAQSection'

import { FAQSectionContainer } from './styles'

export default function LPFAQs({ sections }) {
  return (
    <FAQSectionContainer>
      <LPFAQSection sections={sections} />
    </FAQSectionContainer>
  )
}

LPFAQs.propTypes = {
  sections: PropTypes.array,
}
